import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function getPreview() {
    return (
        <div data-cy="historic-icon-ipcamera-getPreview">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.ipcamera.getPreview" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faCamera} style={{ color: 'rgb(33, 132, 218)' }} size="lg" />
            </Whisper>
        </div>
    );
}
